import React, { Fragment, Suspense, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import Cookies from 'js-cookie';
import qs from 'qs';
import Routers from './routers';
import FullPageLoading from '@/components/fullPageLoading';
import models, { Provider } from './models';
import ModalsProvider from '@/contexts/modals';
import { CurrencyCode, LangCode, LangItem, LANG_LIST } from '@/config/const';
import i18n from '@/i18n';
import BaseInfoRequester from '@/components/baseInfoRequester';
import './assets/iconfont/iconfont.css';

// localStorage 优先：与 setLang 写入一致；Cookie 可能因 domain/Secure 等写入失败而残留旧值
const lang = (localStorage.getItem('lang') || Cookies.get('lang') || 'zh') as LangCode;

const currency = (Cookies.get('currency') || localStorage.getItem('currency') || 'cny') as CurrencyCode;
models.account.setLang(lang);

models.account.setCurrency(currency);

const browserHistory = createBrowserHistory();

if (window.location.search) {
  const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  // @ts-ignore
  window.QUERY = query;

  const { lang: appLang } = query;

  if (appLang) {
    const targetLang = LANG_LIST.find((item: LangItem) => item.value === appLang)?.value || 'zh';

    models.account.setLang(targetLang);
    i18n.changeLanguage(targetLang);
  }
}


const App: React.FC = () => (
  
  <Suspense fallback={<FullPageLoading />}>
    <Provider value={models}>
      <BrowserRouter>
        <Fragment>
          <ModalsProvider>
            <Routers history={browserHistory} />
            <BaseInfoRequester />
          </ModalsProvider>
        </Fragment>
      </BrowserRouter>
    </Provider>
  </Suspense>
);

export default App;
